<template>
    <div v-if="params && params.isActive">
        <ModalDefault @close="close();" :loading="loading">
            <template slot="main">
                <div class="d-flex justify-content-center container flex-column">
                    <p class="modal-title">{{ $t("common.edit") }}</p>

                    <div class="form-group row">
                        <DefaultTextInputBloc
                            :label="$t('createUser.labelFirstName')"
                            :required="true"
                            v-model="user.firstname"
                            :max-length="100"
                        ></DefaultTextInputBloc>
                    </div>
                    <br />
                    <div class="form-group row">
                        <DefaultTextInputBloc
                            :label="$t('createUser.labelLastName')"
                            :required="true"
                            v-model="user.lastname"
                            :max-length="100"
                        ></DefaultTextInputBloc>
                    </div>
                    <br />
                    <div class="form-group row" v-if="isSuperAdmin()">
                        <label class="col-12 col-sm">Type <span>*</span></label>
                        <div class="col-12 col-sm-9">
                            <label for="diam" class="pr-4 pointer">DIAM</label>
                            <input id="diam" class="mr-4 pointer" type="radio" name="userType" value="0" v-model="user.userType" />
                            <label for="client" class="pr-4 pointer">CLIENT</label>
                            <input id="client" class="pointer" type="radio" name="userType" value="1" v-model="user.userType" />
                        </div>
                    </div>
                    <div class="d-flex justify-content-end mt-4">
                        <ClientColorButton
                            :inactiveColor="!isFormValidated"
                            :background-color="currentBrand.linksColor"
                            @click="saveUser();"
                            class="mr-3"
                            :disabled="!isFormValidated"
                            >{{ $t("common.save") }}</ClientColorButton
                        >
                        <ClientColorButton :inactiveColor="true" @click.prevent="close();">{{ $t("actions.cancel") }}</ClientColorButton>
                    </div>
                </div>
            </template>
        </ModalDefault>
    </div>
</template>

<script>
import TextInputBloc from "@/components/ui/Form/TextInputBloc";
import TryLoad from "@/mixins/TryLoadMixin";
import historyService from "@/services/history";
import { OBJECT_TYPE, SHORT_DESCRIPTION } from "@/components/history/constants";
import ModalDefault from "@/components/ui/ModalDefault";
import DefaultTextInputBloc from "@/components/ui/Form/DefaultTextInputBloc";
import userService from "@/services/user";
import { mapState } from "vuex";

export default {
    data() {
        return {
            user: null,
            loading: false
        };
    },
    components: {
        DefaultTextInputBloc,
        ModalDefault,
        TextInputBloc
    },
    props: {
        params: {
            type: Object,
            required: true
        }
    },
    watch: {},
    mixins: [TryLoad],
    mounted() {},
    methods: {
        saveUser() {
            this.loading = true;
            if (parseInt(this.user.userType, 10) === 1) {
                this.user.isSuperAdmin = false;
            }
            userService
                .edit(this.user)
                .then(() => {
                    this.loading = false;
                    this.params.isActive = false;
                    this.dialogSuccess("success");
                    this.$emit("reload");
                    this.close();
                })
                .catch(() => {
                    this.loading = false;
                    this.dialogError("error");
                });
        },
        close() {
            this.params.isActive = false;
        }
    },
    computed: {
        ...mapState("currentUser", ["currentBrand"]),
        isFormValidated() {
            return this.user.firstname && this.user.lastname;
        }
    },
    async created() {
        this.user = Object.assign({}, this.params.user);
    }
};
</script>
<style lang="scss" scoped>
label {
    color: #343434;
    font-size: 18px;
    font-weight: bold;
    font-family: "Oswald", sans-serif;
    span {
        font-size: 14px;
    }
}
</style>



// WEBPACK FOOTER //
// UserEdit.vue?873cfbf4